module.exports = __webpack_public_path__ + "static/img/join-us.9085e4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/gotoContent/join-us.jpg
// module id = aUg6
// module chunks = 0